<template>
  <div class="locations-multi-pickup mt-110">
    <div class="locations-multi-pickup-wrapper">
      <template v-if="isMoskvaPeterburg">
        <h2 class="vz-text-align-left">Транспортировка грузов по маршруту Москва — Санкт-Петербург</h2>
        <b>Транспортная компания "Возовоз"</b> предлагает надёжную и оперативную перевозку 
        грузов между Москвой и Петербургом — двумя крупнейшими деловыми центрами России. Это одно из самых загруженных 
        и стратегически важных направлений, с развитой транспортной инфраструктурой и высоким спросом на логистические 
        услуги. Компания <b>"Возовоз"</b> предлагает профессиональные услуги транспортировки для компаний всех отраслей: 
        дистрибуции, производства, e-commerce, ритейла и B2B-сектора.<br><br>
        Оформить заказ можно через калькулятор стоимости или после 
        <nuxt-link class="text-decoration-underline" :to="{ name: 'personal' }">
          регистрации в личном кабинете со <b>скидкой 10%</b>
        </nuxt-link>.

        <h3 class="mt-50">Преимущества работы с нами:</h3>
        <ul class="public-list public-list-square">
          <li v-for="el in advantagesList">
            <span v-html="el" />
          </li>
        </ul>
        <hr class="my-40">

        <h3>Особенности маршрута Москва — СПб:</h3>
        <ol class="public-list">
          <li v-for="el in routeList">
            <span v-html="el" />
          </li>
        </ol>
        <hr class="my-40">

        <h3>Стоимость и доп. услуги:</h3>
        Итоговая цена зависит от веса, объёма и набора дополнительных опций:
        <ul class="public-list public-list-square">
          <li v-for="el in additionalList">
            <span v-html="el" />
          </li>
        </ul>
        <hr class="my-40">

        <h3>Оплатить можно:</h3>
        <ol class="public-list">
          <li v-for="el in paymentList">
            <span v-html="el" />
          </li>
        </ol>
        <nuxt-link :to="{ name: 'payment-methods' }" target="_blank" class="locations-multi-pickup-link mt-10 text-decoration-underline">
          <vz-icon
            size=16
            class="mr-5"
            variant="primary"
            url="/svg/payment-cards.svg"
          />
          Способы оплаты
        </nuxt-link>
        <hr class="my-40">

        <template v-for="block in blocks">
          <h3>{{ block.title }}</h3>
          <div v-html="block.text" />
          <nuxt-link v-if="block.link" :to="block.link.to" target="_blank" class="locations-multi-pickup-link mt-10 text-decoration-underline">
            <vz-icon
              size=16
              class="mr-5"
              variant="primary"
              :url="block.link.imgUrl"
            />
            {{ block.link.title }}
          </nuxt-link>
          <hr class="my-40">
        </template>
      </template>
      <template v-else>
        <h3 class="vz-text-align-left">
          Услуги по перевозке груза {{ fromToText }}
        </h3>
        <p>Транспортная компания «Возовоз» предлагает выгодные условия для перевозки грузов по направлению 
        {{ from.name }} — {{ to.name }}.
        </p>
        <p>
          Чтобы заказать перевозку, достаточно оставить заявку на сайте 
          или воспользоваться личным кабинетом. Если вы сделаете заказ через личный кабинет, то получите 
          скидку 10%. 
        </p>
        <p>
          Цена на услуги по перевозке грузов зависит от объёма, веса и дополнительных услуг, 
          которые может выбрать клиент: упаковка, специальный транспорт, скан накладной на выдачу, разбор 
          упаковки при доставке до адреса. Мы поможем организовать перевозку вашего груза быстро и качественно. 
          Вы можете выбрать удобные даты забора и доставки груза при оформлении заявки.
        </p>
        <p>
          Оплата перевозки возможна как онлайн, так и на терминалах приёмки и выдачи груза.
          Минимальная стоимость перевозки по направлению {{ from.name }} — {{ to.name }} составляет от 800 рублей.
          Для получения груза достаточно иметь код выдачи из СМС
        </p>
      </template>
    </div>
    <img src="/images/pages/locations/multi-pickup.png" alt="">
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {useCityStore} from '@/stores/city'

const {from, to} = storeToRefs(useCityStore())

const advantagesList = [
  '<b>Регулярные рейсы и фиксированные сроки</b> перемещения по маршруту Москва — Санкт-Петербург',
  '<b>Оптимальные тарифы:</b> стоимость — от 800 ₽',
  '<b>Онлайн-отслеживание</b> через ЛК',
  '<b>Работа по договору</b>, акты, закрывающие документы',
  '<b>Выгодные условия</b> для оптовых и регулярных отправителей',
  '<b>10% скидка</b> при оформлении заявки через личный кабинет'
]

const routeList = [
  'Транспортировка осуществляется по <b>трассе М11 "Нева"</b> и федеральной автодороге <b>М10</b>, что обеспечивает высокую скорость доставки.',
  'В Москве мы оперативно обслуживаем заказы из <b>промзон Лианозово, Рязанского, Очаково-Матвеевского и Чертаново Южного.</b>',
  'В СПб обеспечиваем быструю подачу транспорта в <b>Промышленную зону № 19, Колпино, Шушары, Парнас, Невский район</b> при заказе курьерской доставки "от двери до двери".'
]

const additionalList = [
  'Упаковка, маркировка, фотофиксация',
  'Использование специализированного транспорта для негабаритного груза',
  'Подготовка скана накладной на выдачу',
  'Возврат сопроводительных документов с печатями',
  'Разбор упаковки при вручении',
  'Доставка до двери или терминала'
]

const paymentList = [
  'Онлайн (банковская карта, СБП, счёт для юрлиц)',
  'По QR-коду',
  'В терминалах на пунктах приёма и выдачи груза'
]

const blocks = [
  {
    title: 'Страхование:',
    text: 'Для защиты сохранности груза доступно страхование от ведущих компаний: <b>ВСК, Капитал Полис, СК ПАРИ.</b>',
    link: {
      title: 'Условия страхования',
      imgUrl: '/svg/shield.svg',
      to: { name: 'insurance' }
    }
  },
  {
    title: 'Возврат документов:',
    text: 'Услуга "Возврат сопроводительных документов" позволяет обменяться документами с получателем и получить их обратно с подписями и печатями.',
    link: {
      title: 'Подробнее о возврате СД',
      imgUrl: '/svg/vz-docs-success.svg',
      to: { name: 'return-sd' }
    }
  },
  {
    title: 'Подача претензии:',
    text: 'В случае повреждения, утраты или задержки груза вы можете подать претензию через личный кабинет или электронную почту.',
    link: {
      title: 'Инструкция по подаче претензии',
      imgUrl: '/svg/vz-signature.svg',
      to: { name: 'claim-filing' }
    }
  },
  {
    title: 'Ограничения:',
    text: '<b>Не принимаются к транспортировке:</b> листовое стекло, автомобильные стёкла, грузы без упаковки, а также ряд опасных и скоропортящихся товаров.',
    link: {
      title: 'Список запрещённых грузов',
      imgUrl: '/svg/vz-close.svg',
      to: { name: 'prohibited-goods' }
    }
  },
  {
    title: 'Простое получение:',
    text: 'Для получения груза достаточно сообщить <b>код из SMS</b>, отправленного получателю.',
  },
]

// страница Москва - Санкт-Петербург
const isMoskvaPeterburg = computed(() => {
  return from.value.guid === 'e90f1820-0128-11e5-80c7-00155d903d03' 
    && to.value.guid === 'e90f19de-0128-11e5-80c7-00155d903d03'
})

const fromToText = computed(() => {
  return from.value?.prepositional_name2 && to.value?.prepositional_name3
    ? `из ${from.value.prepositional_name2} в ${to.value.prepositional_name3}`
    : `${from.value.name} — ${to.value.name}`
})
</script>

<style lang="scss" scoped>
.locations-multi-pickup {
  gap: 40px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  p {
    margin-bottom: 10px;
  }

  img {
    width: 100%;
  }

  &-link {
    display: flex;
  }

  @media only screen and (max-width: $pub-sm) {
    display: flex;
    flex-direction: column;
  }
}
</style>
